import type { RoomList_DesignPageQuery } from "@/lib/gql/__generated__/graphql";

type Props = {
	serverModel: RoomList_DesignPageQuery;
};

export const useInitialized = ({ serverModel }: Props) => {
	return {
		data: serverModel,
	};
};
